import { Button, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { useMemo, useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import { setError } from '../../../components/alerts'
import { StatusChip } from '.'
import PrimeTable from '../../../components/PrimeTable'
import ModalDispensacao from './ModalDispensacao'
import { FaRegCheckCircle } from 'react-icons/fa'
import { BsFloppy } from 'react-icons/bs'

const EdicaoDispensacao = ({ dados, voltar, setReloadTablePrincipal }) => {
  const [reloadTable, setReloadTable] = useState(null)
  const [modalDispensar, setModalDispensar] = useState(false)
  const [dadosItem, setDadosItem] = useState([])

  const retornaCentroCusto = useMemo(
    () => ({
      idDispensacao: dados?.[0] || undefined,
      usuarioRegistrou: dados?.[1]?.[1] || [],
      paciente: dados?.[2]?.[1] || [],
      centroDeCusto: dados?.[3]?.[1] || [],
      idPedidoVenda: dados?.[4] || undefined,
      tpSituacao: dados?.[5] || undefined,
      dtInclusao: dados?.[6] || undefined,
      dsObservacoes: dados?.[7] || undefined,
    }),
    [dados],
  )

  const finalizaDispensacao = async () => {
    const payload = {
      idDispensacao: dados?.[0] || undefined,
    }
    const res = await metodoPrograma('finalizaDispensacao', payload)
    if (res.status) {
      voltar()
      setReloadTable((v) => !v)
    } else setError(res.dsErro)
  }

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) {
      voltar()
      setReloadTable((v) => !v)
    } else setError(res.dsErro)
  }

  const handleClickDispensacao = (linha) => {
    setDadosItem(linha)
    setModalDispensar(true)
  }

  const handleCloseDispensacao = () => {
    setModalDispensar(false)
    setReloadTablePrincipal((v) => !v)
  }

  return (
    <>
      <ModalDispensacao
        dados={dadosItem}
        show={modalDispensar}
        handleClose={handleCloseDispensacao}
        setReloadTable={setReloadTable}
      />
      <Formik
        enableReinitialize
        initialValues={retornaCentroCusto}
        onSubmit={async (values, { setSubmitting }) => {
          await salva(values)
          setSubmitting(false)
        }}
      >
        {({ isSubmitting, submitForm }) => (
          <Form style={{ width: '100%', padding: 0 }}>
            <Grid container spacing={2}>
              <Grid item xs={9} md={9}>
                <Field
                  component={TextField}
                  inputLabelProps={{ shrink: true }}
                  name="paciente"
                  label="Paciente"
                  fullWidth
                  disabled
                  margin="dense"
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={3} style={{ paddingTop: 20 }}>
                <StatusChip status={dados?.[5]} />
              </Grid>
              <Grid item xs={12} md={3}>
                <Field
                  component={TextField}
                  inputLabelProps={{ shrink: true }}
                  name="centroDeCusto"
                  label="Centro de Custo"
                  fullWidth
                  disabled
                  margin="dense"
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Field
                  component={TextField}
                  inputLabelProps={{ shrink: true }}
                  name="usuarioRegistrou"
                  label="Registrado por"
                  fullWidth
                  disabled
                  margin="dense"
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Field
                  component={TextField}
                  inputLabelProps={{ shrink: true }}
                  name="idPedidoVenda"
                  label="Pedido Número"
                  fullWidth
                  disabled
                  margin="dense"
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Field
                  component={TextField}
                  inputLabelProps={{ shrink: true }}
                  name="dtInclusao"
                  label="Inclusão"
                  fullWidth
                  disabled
                  margin="dense"
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  component={TextField}
                  inputLabelProps={{ shrink: true }}
                  name="dsObservacoes"
                  label="Observações"
                  fullWidth
                  rows={3}
                  multiline
                  margin="dense"
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <PrimeTable
                  action="listaItens"
                  codigo="CtrlDispensacao"
                  refresh={reloadTable}
                  collumnsDateHour={[3]}
                  parametros={{ idDispensacao: dados?.[0] }}
                  head={[
                    'Código',
                    'Produto',
                    'Lote',
                    'Fabricação',
                    'Validade',
                    'Solicitado',
                    'Dispensado',
                    'Ações',
                  ]}
                  line={(item) => [
                    item[4],
                    item[5],
                    item[6],
                    item[7],
                    item[8],
                    item[9],
                    item[10],
                    '',
                  ]}
                  columnOptions={[
                    {
                      alias: 7,
                      customJsx: ({ linhaOriginal }) =>
                        linhaOriginal[9] > linhaOriginal[10] ? (
                          <Button
                            onClick={(event) => {
                              event.stopPropagation()
                              handleClickDispensacao(linhaOriginal)
                            }}
                            fullWidth
                            variant="outlined"
                            color="primary"
                            size="small"
                          >
                            Dispensar
                          </Button>
                        ) : (
                          <></>
                        ),
                    },
                  ]}
                />
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: 'flex', flexDirection: 'row-reverse' }}
              >
                <Button
                  onClick={finalizaDispensacao}
                  variant="contained"
                  color="primary"
                  style={{ margin: '5px' }}
                  startIcon={<FaRegCheckCircle />}
                >
                  Finalizar Dispensação
                </Button>
                <Button
                  onClick={submitForm}
                  disabled={isSubmitting}
                  variant="contained"
                  color="primary"
                  style={{ margin: '5px' }}
                  startIcon={<BsFloppy />}
                >
                  Salvar
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default EdicaoDispensacao
